import { useMixPanelForTracking } from "../../../shared_utilities/trackMixPanel";

export const useOnboardingMixpanelTrack = () => {
  const { TrackMixPanel } = useMixPanelForTracking();

  const trackOnboardingEvent = (screenName, definition, data = "None") => {
    TrackMixPanel({
      ModuleName: "lorri transporter onboarding",
      ScreenName: screenName,
      Data: data,
      Definition: definition,
    });
  };

  return { trackOnboardingEvent };
};
